/**
 *
 * Asynchronously loads the component for ItemPriceSetupPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
